import { AssistantControllerBaseConfig } from '../../base';
import { AssistantRootController } from './interviewRootInterface';

export function createAssistantRootController(
    config: AssistantControllerBaseConfig
): AssistantRootController {
    return {
        useProps(context, item, props) {
            return {
                redirect: null,
            };
        },
    };
}
